// ADDED: Specialized Hook for the Approver Inbox
import { useState, useCallback, useEffect } from "react";
import { employeeTransactionService } from "../services/employeeTransactionService";

export const useEmployeeTransactionApprovals = (user) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [alertProps, setAlertProps] = useState({ showMessage: false, message: "", isSuccess: false });

  const fetchData = useCallback(async () => {
    if (!user?.employeePersonalInformationId) return;
    setLoading(true);
    try {
      const approverId = user.employeePersonalInformationId;

      const res = await employeeTransactionService.getRequestsForApprover();
      setData(res);
      setFilteredData(res);
    } catch (err) {
      console.error("v2: Approval Fetch Error", err);
    }
    finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { fetchData(); }, [fetchData]);

  useEffect(() => {
    if (!searchTerm) { setFilteredData(data); return; }
    const low = searchTerm.toLowerCase();
    setFilteredData(data.filter(i =>
      i.referenceNumber?.toLowerCase().includes(low) ||
      i.employeeFullName?.toLowerCase().includes(low)
    ));
  }, [searchTerm, data]);

  const handleAction = async (id, type, remarks = "") => {
    if (type === "disapprove") {
      const trimmedRemarks = remarks.trim();

      // 1. Check if empty
      if (!trimmedRemarks) {
        setAlertProps({
          showMessage: true,
          message: "Reason for disapproval is required.",
          isSuccess: false
        });
        return { success: false };
      }

      // 2. Count words (split by whitespace and filter out empty strings)
      const wordCount = trimmedRemarks.split(/\s+/).filter(word => word.length > 0).length;

      if (wordCount < 4) {
        setAlertProps({
          showMessage: true,
          message: "Please provide a more detailed reason (minimum of 4 words).",
          isSuccess: false
        });
        return { success: false };
      }
    }

    setLoading(true);
    
    try {
      const approverId = user.employeePersonalInformationId;
      if (type === "approve") await employeeTransactionService.approveRequest(id, approverId);
      else await employeeTransactionService.disapproveRequest(id, approverId, remarks);

      setAlertProps({ showMessage: true, message: `Action successful`, isSuccess: true });
      await fetchData();
      return { success: true };
    } catch (err) {
      setAlertProps({ showMessage: true, message: `Action failed`, isSuccess: false });
      return { success: false, err };
    } finally { setLoading(false); }
  };



  return {
    loading,
    data: filteredData,
    searchTerm,
    setSearchTerm,
    handleAction,
    alertProps
  };
};